var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-weight-bold color_thead lighten-2 pl-6 pr-6 pt-3 pb-3 ml-4 mr-4 white--text rounded elevation-4",staticStyle:{"top":"-15px","position":"relative"}},[_c('div',{staticClass:"subtitle-1"},[_vm._v(" "+_vm._s(_vm.titre.toUpperCase())+" ")]),_c('div',{staticClass:"caption"},[_vm._v(" "+_vm._s(_vm.sousTitre)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }